import { configureStore } from '@reduxjs/toolkit'
import createSagaMiddleware from 'redux-saga'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import rootReducer from './rootReducer'
import rootSaga from './rootSaga'

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['user'], // only persist user slice
}

const sagaMiddleware = createSagaMiddleware()

const store = configureStore({
  reducer: persistReducer(persistConfig, rootReducer),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: false,
      serializableCheck: false,
    }).concat(sagaMiddleware),
  // eslint-disable-next-line no-undef
  devTools: process.env.NODE_ENV !== 'production',
})

sagaMiddleware.run(rootSaga)

export const persistor = persistStore(store)
export default store
